import React, { useEffect } from 'react';

const InfoModal = ({ show, onHide, title, data, fields }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        const overlay = document.querySelector('.admin-crud-modal-overlay');
        if (overlay) {
          overlay.scrollTop = 0;
        }
      }, 10);
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [show]);

  if (!show) return null;

  if (!data) {
    return (
      <div className="admin-crud-modal-overlay" onClick={onHide}>
        <div className="admin-crud-modal admin-crud-modal-sm" onClick={(e) => e.stopPropagation()}>
          <div className="admin-crud-modal-header">
            <h4 className="admin-crud-modal-title">
              <span>🔍</span> {title}
            </h4>
            <button className="admin-crud-modal-close" onClick={onHide}>✕</button>
          </div>
          <div className="admin-crud-modal-body">
            <div className="admin-crud-empty-state">
              <div className="admin-crud-empty-icon">⚠️</div>
              <div className="admin-crud-empty-text">No data available</div>
            </div>
          </div>
          <div className="admin-crud-modal-footer">
            <button className="admin-crud-btn admin-crud-btn-primary" onClick={onHide}>
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-crud-modal-overlay" onClick={onHide}>
      <div className="admin-crud-modal" onClick={(e) => e.stopPropagation()}>
        <div className="admin-crud-modal-header">
          <h4 className="admin-crud-modal-title">
            <span>🔍</span> {title}
          </h4>
          <button className="admin-crud-modal-close" onClick={onHide}>✕</button>
        </div>
        <div className="admin-crud-modal-body">
          <div className="admin-crud-info-card">
            {fields.map((field, idx) => {
              let value;
              if (field.render) {
                value = field.render(data[field.key], data);
              } else {
                value = data[field.key] || 'N/A';
              }
              
              return (
                <div key={idx} className="admin-crud-info-row">
                  <div className="admin-crud-info-label">{field.label}:</div>
                  <div className="admin-crud-info-value">
                    {field.badge ? (
                      <span className={`admin-crud-badge admin-crud-badge-${field.badge(data[field.key])}`}>
                        {value}
                      </span>
                    ) : (
                      value
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="admin-crud-modal-footer">
          <button className="admin-crud-btn admin-crud-btn-primary" onClick={onHide}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;